import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import NavbarBreadcrumbs from '../navigation/NavbarBreadcrumbs';
import { useUploadContext } from '../../contexts/UploadContext';

export default function Header() {
    const navigate = useNavigate();
    const { activeUploads } = useUploadContext();

    const activeLabel =
        activeUploads.length === 1
            ? activeUploads[0].phaseLabel || 'Uploading...'
            : `Processing ${activeUploads.length} documents...`;

    return (
        <Stack
            direction="row"
            sx={{
                display: { xs: 'none', md: 'flex' },
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: { xs: 2, sm: 3 },
                py: 1.5,
                bgcolor: 'background.paper',
                borderBottom: 1,
                borderColor: 'divider',
                flexShrink: 0,
            }}
            spacing={2}
        >
            <NavbarBreadcrumbs />
            <Stack direction="row" sx={{ gap: 1, alignItems: 'center' }}>
                {activeUploads.length > 0 && (
                    <Chip
                        clickable
                        onClick={() => navigate('/upload')}
                        icon={
                            <CircularProgress
                                size={14}
                                thickness={6}
                                sx={{ color: 'inherit', ml: 1 }}
                            />
                        }
                        label={activeLabel}
                        color="primary"
                        variant="outlined"
                    />
                )}
                <Button disabled sx={{ opacity: '1 !important' }}>
                    {new Date().toLocaleDateString('en-US', {
                        weekday: 'long',
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                    })}
                </Button>
            </Stack>
        </Stack>
    );
}
